import VideoBanner from "@/components/ui/video-banner";
import React from "react";
import { m } from "framer-motion";
import { fadeInUp } from "@/utils/motion/fade-in-up";
export default function Banner({ title, tag, description, video }) {
  return (
    <div className="relative w-full h-full">
      <VideoBanner
        data={{
          video: video,
        }}
      />
      <m.div
        initial={"from"}
        whileInView={"to"}
        variants={fadeInUp(1, 1.5)}
        viewport={{ once: true }}
        className="absolute top-0 left-0 w-full h-screen flex flex-col items-center justify-center md:gap-4 gap-2"
      >
        <p className="text-beige/80 text-sm text-center">{tag}</p>
        <h1 className="font-havletica font-light uppercase text-center text-white">
          {title}
        </h1>
        <p className="text-beige/80 text-sm text-center lg:translate-x-1">
          {description}
        </p>
      </m.div>
    </div>
  );
}
